var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_ index_ page_fixed_form_control_wrapper_ page_hide_upload_file_list_"},[_c('headView',{attrs:{"product":_vm.product}}),_c('policyInfo',{ref:"policyInfo"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }